module.exports = __webpack_public_path__ + "img/partner_img24.00b4644f.png";